import {isTwitterMessageWithExtra} from '../../../helpers/models/messageHelpers';
import {ApiConversationDataGroup} from '../../../models/api/dataGroupModel';
import {postApiAsync} from '../../../services/http/http';
import {performMessageTaskAsyncAction} from '../../../services/tasks/specializedTaskQueues';
import {ThunkAsyncAction} from '../../appThunk';

/*
 * Action creators.
 */

export function toggleTweetIsLikedAsyncAction(messageUid: string): ThunkAsyncAction {
  return async (dispatch) => {
    await dispatch(
      performMessageTaskAsyncAction(messageUid, {
        getOptimisticResult: (message) => {
          if (!isTwitterMessageWithExtra(message)) {
            return {};
          }

          const willBeLiked = !message.twitterExtra.isLiked;
          return {
            messages: [
              {
                ...message,
                twitterExtra: {
                  ...message.twitterExtra,
                  isLiked: willBeLiked,
                },
              },
            ],
          };
        },
        getResultAsync: async (message) => {
          if (!isTwitterMessageWithExtra(message)) {
            return {};
          }

          // TODO: Send metadata for conflict resolution.
          const shouldLike = !message.twitterExtra.isLiked;
          const action = shouldLike ? 'favorite' : 'unfavorite';
          const url = `${message.url}/twitter_favorite/${action}?new=front`;
          return postApiAsync(ApiConversationDataGroup, url, {});
        },
      }),
    );
  };
}
